import React from 'react';
import {CircularProgress, Stack} from "@mui/joy";
import Typography from "@mui/joy/Typography";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import BaseApi from "../../utils/BaseApi";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import ChecklistTypeQuestionCreate from "./ChecklistTypeQuestionCreate";
import withRouter from "../../utils/withRouter";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import ChecklistConvertionRuleCreate from "./ChecklistConvertionRuleCreate";
import ChecklistConvertionRuleUpdate from "./ChecklistConvertionRuleUpdate";

// icons
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";


class ChecklistTypeDetail extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            checklistType: null,
            checklistTypeQuestions: null,
            checklistConvertionRules: null,
        };
    }

    async componentDidMount(){
        await this.retrieveChecklistType();
        await this.retrieveChecklistTypeQuestions();
        await this.retrieveChecklistConvertionRules();
    }

    async retrieveChecklistConvertionRules(){
        const api = new BaseApi();
        let url = 'checklist_convertion_rule/';
        let params = {
            page_size: 10000,
            type: this.props.params.checklistTypeId
        }
        let response = await api.get(url, params);
        this.setState(
            {
                checklistConvertionRules: response.data.results,
            }
        );
    }

    async retrieveChecklistType() {
        const api = new BaseApi();
        let url = 'checklist_type/'+this.props.params.checklistTypeId;
        let params = {}
        let response = await api.get(url, params);
        this.setState(
            {
                checklistType: response.data,
            }
        );
    }

    async retrieveChecklistTypeQuestions() {
        const api = new BaseApi();
        let url = 'checklist_type_question/';
        let params = {
            page_size: 10000,
            type: this.props.params.checklistTypeId
        }
        let response = await api.get(url, params);
        this.setState(
            {
                checklistTypeQuestions: response.data.results,
            }
        );
    }

    async deleteQuestion(id){
        const api = new BaseApi();
        let url = `checklist_type_question/${id}/`;
        await api.delete(url);
        await this.retrieveChecklistTypeQuestions();
    }

    async moveUpQuestion(id){
        const url = `checklist_type_question/${id}/move_up/`;
        const api = new BaseApi();
        await api.get(url);
        await this.retrieveChecklistTypeQuestions(true)
    }

    async moveDownQuestion(id){
        const url = `checklist_type_question/${id}/move_down/`;
        const api = new BaseApi();
        await api.get(url);
        await this.retrieveChecklistTypeQuestions(true)
    }

    async deleteRule(id){
        const api = new BaseApi();
        let url = `checklist_convertion_rule/${id}/`;
        await api.delete(url);
        await this.retrieveChecklistConvertionRules();
    }

    render() {
        if (!this.state.checklistType || !this.state.checklistTypeQuestions || !this.state.checklistConvertionRules) {
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={2}
            >
                <Typography
                    level={'h3'}
                >
                    {this.state.checklistType.title}
                </Typography>
                <CommonPaginatedTable
                    title={'Вопросы'}
                    callBack={this.retrieveChecklistTypeQuestions.bind(this)}
                    extraComponents={[
                        {
                            component: ChecklistTypeQuestionCreate,
                            componentProps: {
                                checklistType: this.state.checklistType
                            }
                        }
                    ]}
                    data={this.state.checklistTypeQuestions}
                    fields={[
                        {
                            title: 'Номер по порядку',
                            name: 'order',
                            visible: true,
                        },
                        {
                            title: 'Вопрос',
                            name: 'question.title',
                            visible: true,
                        },
                        {
                            title: '',
                            visible: true,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: DeleteIcon,
                                color: 'danger',
                            },
                            callBack: this.deleteQuestion.bind(this),
                        },
                        {
                            title: '',
                            visible: true,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: KeyboardArrowUpIcon,
                            },
                            callBack: this.moveUpQuestion.bind(this),
                        },
                        {
                            title: '',
                            visible: true,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: KeyboardArrowDownIcon,
                            },
                            callBack: this.moveDownQuestion.bind(this),
                        },
                    ]
                    }
                />
                <CommonPaginatedTable
                    title={'Правила конвертации'}
                    callBack={this.retrieveChecklistConvertionRules.bind(this)}
                    extraComponents={[
                        {
                            component: ChecklistConvertionRuleCreate,
                            componentProps: {
                                checklistType: this.state.checklistType
                            }
                        }
                    ]}
                    data={this.state.checklistConvertionRules}
                    fields={[
                        {
                            title: 'Тип',
                            name: 'type_human',
                            visible: true,
                        },
                        {
                            title: 'Сущность',
                            name: 'entity_human',
                            visible: true,
                        },
                        {
                            title: '',
                            visible: true,
                            component: ChecklistConvertionRuleUpdate,
                            componentProps: {},
                        },
                        {
                            title: '',
                            visible: true,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: DeleteIcon,
                                color: 'danger',
                            },
                            callBack: this.deleteRule.bind(this),
                        },
                    ]
                    }
                />
            </Stack>
        )
    }
}

export default withRouter(ChecklistTypeDetail)
